export default __webpack_public_path__ + "assets/ak-cached/2h/images/Icon - Disneyplus.svg";